<template>
  <b-row>
    <b-col
      v-if="documentosDigitales && dataDocuments"
      lg="12"
      xl="12"
    >
      <b-card>
        <b-row class="mb-1">
          <b-col
            xl="12"
            lg="12"
            md="12"
            sm="12"
          >
            <b-alert
              show
              variant="primary"
            >
              <div class="alert-body">
                <feather-icon
                  class="mr-25"
                  icon="FolderIcon"
                />
                <span class="ml-25">Documentos</span>
              </div>
            </b-alert>
          </b-col>
        </b-row>

        <b-row>
          <documento
            v-for="doc in documentsMatchList"
            :id="doc.id"
            :key="doc.id"
            :name="doc.name"
            :url="doc.url"
            :required="doc.required"
            :ok="doc.validate"
            :is-disabled="isDisabledCheckBtns"
            @update="updateCheckBtns"
          />
          <!-- :is-disabled="isDisabledCheckBtns" -->
        </b-row>
      </b-card>
    </b-col>
    <b-col v-else>
      <b-card>
        <b-row>
          <b-col cols="12">
            <b-alert
              show
              variant="primary"
            >
              <div class="alert-body">
                <feather-icon
                  class="mr-25"
                  icon="FolderIcon"
                />
                <span class="ml-25">Documentos</span>
              </div>
            </b-alert>
          </b-col>
          <b-col>
            <h5 class="ml-1">
              Esta convocatoria no requiere estos datos.
            </h5>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BAlert,
  BCard,
  BCol,
  BRow,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import { localize } from 'vee-validate'
// import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import es from 'vee-validate/dist/locale/es.json'
import PrebecariosService from '@/services/PrebecariosService'
import BecariosService from '@/services/BecariosService'
import CatalogosService from '@/services/CatalogosService'
import Documento from './components/Doc.vue'

localize('es', es)

export default {
  name: 'DocumentosAcciones',
  directives: {
    Ripple,
  },
  components: {
    BAlert,
    BCard,
    BCol,
    BRow,
    Documento,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    dataDocuments: {
      type: [Array],
      default: () => [],
    },
    dataActions: {
      type: Object,
      default: () => {},
    },
    documentosDigitales: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isDisabled: true,
      isDisabledAceptar: true,
      status: { PENDIENTE: 1, ACEPTADO: 2, RECHAZADO: 3 },
      detallesPendiente: null,
      detallesRechazado: null,
      isDisabledCheckBtns: false,

      tipoConvocatoriaId: null,
      catDocuments: [],
      documentsMatchList: [],
      documents: [],
      curp: '',
      // RULES
      // required,
    }
  },
  computed: {
    messageOK() {
      return msg => this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'OK',
            icon: 'CheckCircleIcon',
            text: msg,
            variant: 'success',
          },
        },
        { position: 'top-center' },
      )
    },
    messageER() {
      return msg => this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertTriangleIcon',
            text: msg,
            variant: 'danger',
          },
        },
        { position: 'top-center' },
      )
    },
  },
  mounted() {
    const { curp, tipo_convocatoria: tipoConvocatoria } = this.dataActions
    this.curp = curp
    this.tipoConvocatoriaId = tipoConvocatoria
    // console.log('convocartotiaID', this.tipoConvocatoriaId)
    this.documents = [...this.dataDocuments]
    // console.log('documents mounted', this.dataDocuments)
    // console.log(this.dataDocuments)
    this.fetchCatDocumentosConvocatoria()
    // this.disableBtns()
  },
  methods: {
    msg({ title, text, icon }) {
      return this.$swal({
        title,
        text,
        icon,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    msgRedirec({
      title, text, icon, route,
    }) {
      this.$swal({
        title,
        text,
        icon,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      }).then(res => {
        if (res.value) {
          this.$router.push({ name: `${route}` })
        }
      })
    },
    disableBtns() {
      const status = this.dataActions.estatus_solicitud
      if (status === this.status.PENDIENTE) {
        this.isDisabled = false
        this.isDisabledCheckBtns = false
        this.isDisabledAceptar = this.validateDocuments()
      } else if (status === this.status.ACEPTADO) {
        this.isDisabledAceptar = true
        this.isDisabledCheckBtns = true
      } else if (status === this.status.RECHAZADO) {
        this.isDisabledAceptar = true
        this.isDisabledCheckBtns = true
      }
    },
    setStatus(status, details) {
      PrebecariosService.setStatusSolicitud({
        // prebecario: this.dataActions.curp,
        prebecario: this.dataActions.id,
        detalles: details,
        estatus_solicitud: status,
        // tipo_convocatoria: this.dataActions.tipo_convocatoria,
        // folio: this.dataActions.folio,
        // convocatoria_descripcion: this.dataActions.convocatoria_descripcion,
        // user: this.dataActions.user,
      })
        .then(() => {
          this.msgRedirec({
            title: 'OK',
            text: 'Operación realizada correctamente!',
            icon: 'success',
            route: 'prebecarios-list',
          })
          // this.messageOK('Se actualizo el estatus correctamente')
          // this.$router.push({ name: 'prebecarios-list' })
        })
        .catch(() => {
          this.msg({
            title: 'Error',
            text: 'Lo sentimos algo salio mal',
            icon: 'error',
          })
        })
    },
    aceptarPrebecario() {
      BecariosService.addBecario({
        // prebecario_id: this.data.curp,
        prebecario_id: this.dataActions.id,
        curp: this.curp,
        convocatoria: this.tipoConvocatoriaId,
      })
        .then(resp => {
          if (resp.status === 201) {
            this.msgRedirec({
              title: 'OK',
              text: 'Operación realizada con éxito',
              icon: 'success',
              route: 'prebecarios-list',
            })
          }
        })
        .catch(error => {
          this.msg({
            title: 'Error',
            // text: 'Lo sentimos algo salio mal',
            text: error.response.data.error,
            icon: 'error',
          })
          // this.messageER('Lo sentimos, algo salio mal.')
        })
    },
    validFormPendiente() {
      this.$refs.pendiente
        .validate()
        .then(success => {
          if (success) {
            this.setStatus(this.status.PENDIENTE, this.detallesPendiente)
          } else {
            this.messageER('Es necesario especificarl el motivo.')
          }
        })
        .catch(() => {
          this.messageER('Lo sentimos, algo salio mal.')
        })
    },
    validFormRechazado() {
      this.$refs.rechazado
        .validate()
        .then(success => {
          if (success) {
            this.setStatus(this.status.RECHAZADO, this.detallesRechazado)
          } else {
            this.messageER('Es necesario especificarl el motivo.')
          }
        })
        .catch(() => {
          this.messageER('Lo sentimos, algo salio mal.')
        })
    },
    validateDocuments() {
      // console.log('length match list = ', this.documentsMatchList.length)
      const statusDocs = []
      if (this.documentsMatchList.length !== 0) {
        this.documentsMatchList.forEach(e => {
          let status = false
          if (e.required && e.url) {
            status = e.validate
          } else if (!e.required && e.url) {
            status = e.validate
          } else if (!e.required && !e.url) {
            status = true
          }
          const s = {
            id: e.id,
            status,
          }
          statusDocs.push(s)
        })
        const isDisabledAceptar = statusDocs.find(e => !e.status)
        return isDisabledAceptar
      }
      return true
    },
    updateCheckBtns(o) {
      this.documentsMatchList.forEach(e => {
        if (e.id === o.id) e.validate = o.value
      })
      this.disableBtns()
    },
    async documentosUpdate(o) {
      const { id } = o.tipo_documento
      const match = this.documentsMatchList.find(e => e.documentoId === id)
      match.id = o.id
      match.url = o.documento
      match.validate = o.validado
    },
    fetchDocumetsPrebecarios(prebecario) {
      const vm = this
      PrebecariosService.listDocumentsPrebcario(prebecario)
        .then(response => {
          vm.documents = { ...response.data }
        })
    },
    fetchCatDocumentosConvocatoria() {
      CatalogosService.getCatPubConvocatoriaDocumento({
        convocatoria: this.tipoConvocatoriaId,
      }).then(resp => {
        // console.log(resp)
        this.documentosList = []
        this.catDocuments = resp.data
        this.catDocuments.forEach(e => {
          const { nombre, id, requerido } = e.documento
          const doc = { id, nombre, requerido }
          this.documentosList.push(doc)
        })
        this.matchDocuments(this.documentosList)
      })
    },
    matchDocuments(documentsList) {
      //  NOTA:
      //  dataDocumentos son los documentos que subio el aspirante.
      //  documentsList son los documentos que requiere esa convocatoria.
      // console.log('parameter!!', documentsList)
      this.documentsMatchList = []
      documentsList.forEach(e => {
        const doc = this.documents.find(o => o.tipo_documento.id === e.id)
        let regDocumento = null
        if (doc) {
          const {
            id, documento, validado, tipo_documento: tipoDocumento,
          } = doc
          regDocumento = {
            id,
            url: documento,
            documentoId: tipoDocumento.id,
            name: tipoDocumento.nombre,
            required: tipoDocumento.requerido,
            validate: validado,
          }
        } else {
          regDocumento = {
            id: null,
            url: null,
            documentoId: e.id,
            name: e.nombre,
            required: e.requerido,
            validate: null,
          }
        }
        this.documentsMatchList.push(regDocumento)
      })
      this.disableBtns()
    },
  },
}
</script>

<style></style>
